import { render, staticRenderFns } from "./HorizontalStoreCard.vue?vue&type=template&id=73be3a98&scoped=true"
import script from "./HorizontalStoreCard.vue?vue&type=script&lang=ts"
export * from "./HorizontalStoreCard.vue?vue&type=script&lang=ts"
import style0 from "./HorizontalStoreCard.vue?vue&type=style&index=0&id=73be3a98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73be3a98",
  null
  
)

export default component.exports